






























import ResourceDetailLoader from "../../../components/ResourceDetailLoader.vue";
import { createComponent } from "@vue/composition-api";
import ResourceItemTable from "@/components/resource/ResourceItemTable.vue";
import { productListResource } from "@megarax/client/src/resources/plm";
import ProductListUnitsTableDetail from "./ProductListUnitsTableDetail.vue";

export default createComponent({
  components: {
    ResourceItemTable,
    ProductListUnitsTableDetail,
    ResourceDetailLoader,
  },
  setup(props, ctx) {
    return {
      resource: productListResource,
    };
  },
});
